var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderMaler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 111,
    viewBox: "0 0 108 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107.48,
    height: 110.06,
    rx: 20,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0659 39H42.4295C42.1595 39 41.9006 39.109 41.7098 39.303C41.5189 39.497 41.4117 39.7602 41.4117 40.0345V45.9166C41.4117 46.0524 41.438 46.1869 41.4891 46.3124C41.5403 46.438 41.6153 46.552 41.7098 46.6481C41.8043 46.7441 41.9165 46.8203 42.04 46.8723C42.1634 46.9243 42.2958 46.9511 42.4295 46.9511H68.0659C68.1996 46.9511 68.332 46.9243 68.4554 46.8723C68.5789 46.8203 68.6911 46.7441 68.7856 46.6481C68.8801 46.552 68.9551 46.438 69.0063 46.3124C69.0574 46.1869 69.0837 46.0524 69.0837 45.9166V40.0345C69.0837 39.7602 68.9765 39.497 68.7856 39.303C68.5948 39.109 68.3359 39 68.0659 39V39Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.885 42.9711H40.1403C39.573 42.9723 39.0293 43.2018 38.6281 43.6096C38.227 44.0173 38.0012 44.5699 38 45.1465V47.0264C38.0015 47.4283 38.1126 47.822 38.3211 48.1635C38.5295 48.505 38.827 48.7811 39.1806 48.961L54.0795 56.748C54.4298 56.9304 54.7238 57.2075 54.9291 57.5488C55.1343 57.8902 55.2428 58.2825 55.2427 58.6826V60.6039",
    stroke: "#666666",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42.9711H68.4908",
    stroke: "#666666",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.544 60.6038H52.9712V74.4502C52.9712 74.596 53.0282 74.7359 53.1297 74.839C53.2311 74.9421 53.3687 75 53.5121 75H57.0249C57.1684 75 57.3059 74.9421 57.4074 74.839C57.5088 74.7359 57.5658 74.596 57.5658 74.4502V60.6038H57.544Z",
    fill: "#666666"
  })));
}
export default SvgPlaceholderMaler;